<template>
    <main class="flex">
        <div class="mr-16 mb-32 flex-grow">

            <p v-if="toggleFieldsToText" class="block w-full text-body font-semibold">
                {{ form.question }}
            </p>
            <autogrow-input
                v-else
                ref="question-input"
                v-model="form.question"
                :disabled="disabled"
                :placeholder="$t('interview.your_question')"
                :tab-index="tabIndex"
                font-size="20"
                input-class="font-semibold"
                @focusout="updateAnswer"
            ></autogrow-input>

            <p v-if="toggleFieldsToText" class="block w-full text-body-sm pt-32">
                {{ form.answer ? form.answer : '/' }}
            </p>
            <autogrow-input
                v-else
                v-model="form.answer"
                :disabled="disabled"
                :placeholder="$t('interview.answer_of_candidate')"
                :tab-index="tabIndex"
                font-size="16"
                @focusout="updateAnswer"
            ></autogrow-input>
        </div>

        <simple-button
            class="hide-from-print"
            display="danger"
            icon="delete"
            :loading="deletingAnswer"
            small
            v-if="!disabled && showDeleteButton"
            @click="deleteAnswer"
        >
            {{ $t('general.delete') }}
        </simple-button>
    </main>
</template>

<script>
import AutoGrowingInput from './AutoGrowingInput.vue';
import InterviewAnswer from '../../models/InterviewAnswer';
import Form from '../../etc/forms/Form';
import * as interviews from '../../services/InterviewService';
import {normalizeJson} from '../../../shared/helpers';
import SvgIcon from './SvgIcon.vue';
import SimpleButton from "./SimpleButton.vue";
import TextArea from "../forms/TextArea.vue";
import {useRepo} from 'pinia-orm';

export default {
    components: {
        TextArea,
        SimpleButton,
        SvgIcon,
        'autogrow-input': AutoGrowingInput,
    },
    props: {
        disabled: Boolean,
        answer: InterviewAnswer,
        tabIndex: null,
        showDeleteButton: {type: Boolean, default: true},
        toggleFieldsToText: Boolean,
    },
    data: function () {
        return {
            deletingAnswer: false,
            form: new Form([
                {name: 'question', value: this.answer.question || ''},
                {name: 'answer', value: this.answer.answer || ''},
            ]),
        };
    },
    methods: {
        updateAnswer() {
            if (!this.form.isDirty()) {
                return;
            }

            return this.form.submit(data => interviews.updateAnswer(this.answer.id, {
                data: {attributes: data},
            })).then(result => {
                return useRepo(InterviewAnswer).save(normalizeJson(result));
            });
        },
        deleteAnswer(answer) {
            this.deletingAnswer = true;

            interviews.deleteAnswer(this.answer.id).then(() => {
                return useRepo(InterviewAnswer).destroy(this.answer.id);
            }).then(() => {
                this.deletingAnswer = false;
            });
        },
        focus() {
            this.$refs['question-input'].focus();
        },
    },
};
</script>
